{
  "changePassword": "Change password",
  "changeUser": "Change User",
  "description": "Password is expired and must be changed",
  "successMessage": "Password successfully changed!"
}